import React from 'react';
import './featured-projects-card.css'; // Import the CSS for this component

const FeaturedProjectsCard = ({ photo, title, body }) => {
  return (
    <div className="card-style">
      <img className="featured-project-image" src={photo} alt={title} />
      <div className="featured-project-content">
        <h3 className="featured-project-title">{title}</h3>
        <p className="featured-project-description">{body}</p>
      </div>
    </div>
  );
};

export default FeaturedProjectsCard;